import React from 'react';
import { useDispatch } from 'react-redux';
import {
    Divider, Grid, Text, Box
} from 'components/ui';
import InfoButton from 'components/InfoButton/InfoButton';
import Actions from 'actions/Actions';
import InputSwitch from 'components/Inputs/InputSwitch/InputSwitch';
import { space, fontSizes } from 'style/config';
import agentAwareUtils from 'utils/AgentAware';
import userActions from 'actions/UserActions';

import { wrapFunctionalComponent } from 'utils/framework';

function PhoneVerification({ getText, isPhoneVerificationEligible }) {
    const dispatch = useDispatch();

    const handlePhoneVerificationInfoButtonClick = () => {
        dispatch(
            Actions.showInfoModal({
                isOpen: true,
                title: getText('phoneVerificationInfoTitle'),
                message: getText('phoneVerificationInfoMessage'),
                buttonText: getText('GotIt'),
                callback: () => dispatch(Actions.showInfoModal({ isOpen: false })),
                showCloseButton: true
            })
        );
    };

    const handleToggleChange = () => {
        const optionParams = {
            isPhoneVerificationEligible: !isPhoneVerificationEligible
        };
        const successCallback = () => {};
        const failureCallback = () => {};
        dispatch(userActions.updateUserFragment(optionParams, successCallback, failureCallback));
    };

    return (
        <>
            <Divider marginY={space[5]} />
            <Grid
                marginBottom={4}
                columns='1fr auto'
                alignItems='flex-start'
            >
                <Box>
                    <Text fontWeight='bold'>{getText('phoneVerificationLabel')}</Text>
                    <Box css={{ whiteSpace: 'nowrap' }}>
                        {isPhoneVerificationEligible ? getText('phoneVerificationEnabled') : getText('phoneVerificationNotEnabled')}
                        <InfoButton
                            isOutline
                            padding={0}
                            margin={0}
                            marginLeft={1}
                            onClick={handlePhoneVerificationInfoButtonClick}
                        />
                    </Box>
                </Box>
                <Box className={agentAwareUtils.applyHideAgentAwareClass()}>
                    <InputSwitch
                        name='phoneVerification'
                        checked={isPhoneVerificationEligible}
                        onChange={handleToggleChange}
                        size={fontSizes.xl}
                    />
                </Box>
            </Grid>
        </>
    );
}

export default wrapFunctionalComponent(PhoneVerification, 'PhoneVerification');
